import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { useLocation, withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import MenuLink from "components/MenuLink"
import jwt from "jsonwebtoken"
import { useUser } from "hooks/useUser"

const SidebarContent = props => {
  const { payload: user } = useUser()
  const ref = useRef()

  const location = useLocation()

  useEffect(() => {
    const pathName = location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")

      for (let i = 0; i < items.length; ++i) {
        const itemPath = items[i].pathname
        if (
          pathName === itemPath ||
          (itemPath !== "/" && String(pathName).startsWith(itemPath))
        ) {
          matchingMenuItem = items[i]
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  useEffect(() => {
    ref.current.recalculate()
  })

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <MenuLink
              label="Indicadores"
              active={location.pathname.includes("/indicadores")}
              icon="bx bx-line-chart"
              to="/#"
              permission={["indicadores"]}
              className="has-arrow"
            >
              <MenuLink label="Resumo" to="/indicadores" />
              <MenuLink
                label="Aguardando Embossing"
                to="/indicadores/embossing"
              />
              <MenuLink label="Distribuições" to="/indicadores/distribuicoes" />
              <MenuLink label="Tempo Médio" to="/indicadores/tempo-medio" />
              <MenuLink label="Eficiência" to="/indicadores/eficiencia" />
            </MenuLink>
            <MenuLink
              label="Rastreio"
              to="/#"
              permission={["rastreio"]}
              icon="bx bx-search-alt"
              className="has-arrow"
            >
              <MenuLink label="Pedidos" to="/rastreio" />
              <MenuLink label="Exportação" to="/rastreio/exportacao" />
              <MenuLink
                label="Templates"
                to="/rastreio/exportacao/templates"
                roleId={user?.roleId}
                checkRolesIds={[1, 2]}
                displayNone={user ? false : true}
              />
            </MenuLink>
            <MenuLink
              label="Chamados"
              to="/chamados"
              permission={["chamado"]}
              icon="bx bx-receipt"
            />
            <MenuLink
              label="Monitoramento"
              to="/monitoramento-jobs"
              permission={["monitoramento"]}
              icon="bx bx-file-find"
            />
            <MenuLink
              label="Configurações"
              active={location.pathname.includes("/configuracoes")}
              to="/#"
              permission={[
                "configuracoes",
                "blocklist_cep",
                "gestao_courrier",
                "gestao_status",
                "gestao_status_arquivo",
              ]}
              icon="bx bxs-briefcase-alt-2"
              className="has-arrow"
            >
              <MenuLink
                label="Gestão Acessos"
                active={location.pathname.includes("/configuracoes/acessos")}
                to="/#"
                permission={["configuracoes"]}
                className="has-arrow"
              >
                <MenuLink
                  label="Usuários"
                  permission={["configuracoes"]}
                  to="/configuracoes/acessos/usuarios"
                />
                <MenuLink
                  label="Perfis"
                  permission={["configuracoes"]}
                  to="/configuracoes/acessos/perfis"
                />
              </MenuLink>
              <MenuLink
                label="Gestão Operação"
                // permission={["gestao_courrier", "gestao_status"]}
                active={location.pathname.includes("/configuracoes/operacao")}
                to="/#"
                className="has-arrow"
              >
                <MenuLink
                  label="Gestão de Transportadora"
                  // permission={["gestao_courrier"]}
                  to="/configuracoes/operacoes/courrier"
                />
                <MenuLink
                  label="Gestão de Status"
                  // permission={["gestao_status"]}
                  to="/configuracoes/operacoes/status"
                />
              </MenuLink>

              <MenuLink
                label="Parametrizações"
                // permission={["gestao_courrier", "gestao_status"]}
                active={location.pathname.includes("/configuracoes/params")}
                to="/#"
                className="has-arrow"
              >
                <MenuLink
                  label="Produtos"
                  permission={["configuracoes"]}
                  to="/configuracoes/params/produtos"
                />
                <MenuLink
                  label="Fabricas"
                  permission={["configuracoes"]}
                  to="/configuracoes/params/fabricas"
                />
                <MenuLink
                  label="Transportadoras"
                  permission={["configuracoes"]}
                  to="/configuracoes/params/transportadoras"
                />
                <MenuLink
                  label="Status"
                  permission={["configuracoes"]}
                  to="/configuracoes/params/statuses"
                />
                <MenuLink
                  label="Status Safra"
                  permission={["configuracoes"]}
                  to="/configuracoes/params/status-safra"
                />
              </MenuLink>
              <MenuLink
                label="Atendimento"
                to="/#"
                active={location.pathname.includes(
                  "/configuracoes/atendimento"
                )}
                permission={["configuracoes"]}
                className="has-arrow"
              >
                <MenuLink
                  label="Canais de Atendimento"
                  permission={["configuracoes"]}
                  to="/configuracoes/atendimento/canais-de-atendimento"
                />
                <MenuLink
                  label="Filas de Atendimento"
                  permission={["configuracoes"]}
                  to="/configuracoes/atendimento/filas-de-atendimento"
                />
                <MenuLink
                  label="Steps"
                  permission={["configuracoes"]}
                  to="/configuracoes/atendimento/steps"
                />
                <MenuLink
                  label="Tipos de chamados"
                  permission={["configuracoes"]}
                  to="/configuracoes/atendimento/tipo-de-chamado"
                />
              </MenuLink>
              <MenuLink
                label="Trilha Auditoria"
                to="/configuracoes/auditoria"
                permission={["configuracoes"]}
              />
            </MenuLink>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
